import ModuleSlider from '../components/map/ModuleSlider';
import McClientLogo from '../components/McClientLogo';

function MysteryClient() {
  return (
    <>
      {/* Company logo from clients.json — visible above the MC iframe */}
      <McClientLogo />

      {/* Module Slider - Navigation between modules */}
      <ModuleSlider
        showNavbarControls={false}
        setShowNavbarControls={() => {}}
        showSimfixAreas={false}
        setShowSimfixAreas={() => {}}
        showPredictMode={false}
        setShowPredictMode={() => {}}
        showTlGreenWave={false}
        setShowTlGreenWave={() => {}}
        showAssignx={false}
        setShowAssignx={() => {}}
      />
    </>
  );
}

export default MysteryClient;
